// extracted by mini-css-extract-plugin
module.exports = {"main":"Page_main__36Mwi","results":"Page_results__AEO_0","title":"Page_title__ydB_0"};